import React from 'react';
import PropTypes from 'prop-types';

const ColorSquare = ({ color, active, onClick }) => (
  <div
    onClick={onClick}
    className={`product-container__color ${active && 'product-container__color__active'}`}
  >
    <div style={{ backgroundColor: color }} />
  </div>
);

ColorSquare.propTypes = {
  color: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ColorSquare;



// WEBPACK FOOTER //
// ./src/components/ui/Product/ColorSquare/index.js